module.exports = __webpack_public_path__ + "static/img/Humphrey.0836058.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Humphrey.jpg
// module id = nnJy
// module chunks = 0